import { api } from "@/services";
import { SharedServicesResponse } from "@/types/Shared";
import { useFilter } from "@/utils";

type HasRegisterProps = {
  UserEmail?: string;
  UserDocument?: string;
  isPhysicalPerson: boolean;
};

type HasRegisterReturn = [
  Response: {
    msg: string;
    email: boolean;
    doc: boolean;
  },
  HError: string
];

async function useAsyncHasRegister({
  UserEmail,
  UserDocument,
  isPhysicalPerson
}: HasRegisterProps): Promise<HasRegisterReturn> {
  let HResponse = null;
  let HError = null;

  const Controller = new AbortController();

  const EmailRequestBody = {
    email: UserEmail
  };

  const DocRequestBody = {
    [isPhysicalPerson ? "cpf" : "cnpj"]: useFilter(UserDocument, {
      type: "number"
    })
  };

  const MakeRequest = async () => {
    try {
      const RespEmail: { status: number; data: SharedServicesResponse } =
        await api.get("/Client/Exists", {
          signal: Controller.signal,
          params: EmailRequestBody
        });

      if (RespEmail.status === 200) {
        if (RespEmail.data.status) {
          HResponse = {
            msg: RespEmail.data.msgs[0],
            email: true,
            doc: false
          };
        } else {
          const RespDoc: { status: number; data: SharedServicesResponse } =
            await api.get("/Client/Exists", {
              signal: Controller.signal,
              params: DocRequestBody
            });

          if (RespDoc.status === 200) {
            if (RespDoc.data.status) {
              HResponse = {
                msg: RespDoc.data.msgs[0],
                email: false,
                doc: true
              };
            } else {
              throw new Error("Cliente não tem cadastro.");
            }
          } else {
            throw new Error(
              "Não foi possível validar se o cliente já existe, por favor continue seu cadastro."
            );
          }
        }
      } else {
        throw new Error(
          "Não foi possível validar se o cliente já existe, por favor continue seu cadastro."
        );
      }
    } catch (Herr) {
      HError = Herr.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [HResponse, HError];
}

export { useAsyncHasRegister };
